/**
 * @preserve golfbox.lib-history.js
 */
(function ($, window, undefined) {
    if (window.golfbox === undefined)
        window.golfbox = window.gb = {};

    var document = window.document,
		navigator = window.navigator,
		location = window.location,
		_ = window.golfbox;

    _.history = {
        back: function () {
            $.get('/History/Back', function (data) {
                if (data === location.pathname) {
                    window.history.back();
                } else {
                    window.location.replace(data);
                }
            })
            .fail(function () {
                window.history.back();
            });
        }
    };
})(jQuery, window);